import { a3 as PRODUCT, a4 as RANGE, a5 as SUBCATEGORY, a6 as CATEGORY, a7 as SITE, r as BUSINESS } from './currency-7be6806c.js';
import { am as indexDBBreadcrumbs, b as isIndexDBEnabled } from './index-e29b327a.js';

const getProductInfoFromBreadcrumbs = (breadcrumbs) => {
  let productCategory = '';
  let productSubCategory = '';
  let productRange = '';
  let productName = '';
  const getProductName = (breadcrumb) => {
    switch (breadcrumb.itemType) {
      case RANGE:
      case PRODUCT:
        return breadcrumb.nameForChat;
      default:
        return breadcrumb.name;
    }
  };
  breadcrumbs.forEach((breadcrumb) => {
    switch (breadcrumb.itemType) {
      case CATEGORY:
        productCategory = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case SUBCATEGORY:
        productSubCategory = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case RANGE:
        productRange = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case PRODUCT:
        productName = getProductName(breadcrumb);
        break;
    }
  });
  return {
    productCategory,
    productSubCategory,
    productRange,
    productName,
  };
};
const getFilteredBreadcrumbs = (breadcrumbs, breadcrumbItemTypes = [SITE, BUSINESS]) => breadcrumbs.filter((breadcrumb) => {
  return !breadcrumbItemTypes.includes(breadcrumb.itemType);
});
const storeBreadcrumbs = async ({ id, name, url, subcategory, breadcrumbs, storageName, pageName, }) => {
  try {
    await indexDBBreadcrumbs.handleSaveInIndexDB(Object.assign({ targetName: name, targetId: id, targetUrl: url, pageName, baseBreadCrumbs: breadcrumbs, storageName }, (subcategory ? { parentSubCategory: {
        id: subcategory.id,
        itemType: SUBCATEGORY,
        name: subcategory.name,
        nameForChat: '',
        url: subcategory.url,
      } } : {})));
  }
  catch (e) {
    console.error(`[PES]: ${pageName} breadcrumbs for ${id} could not be saved in indexDB`, e);
  }
};
const storeOnClick = async (e, data) => {
  if (!isIndexDBEnabled()) {
    return;
  }
  e.preventDefault();
  await storeBreadcrumbs(data);
};
const passBreadcrumbsParams = (storeBreadcrumbsParams) => {
  return (event) => storeOnClick(event, storeBreadcrumbsParams);
};

export { getFilteredBreadcrumbs as a, getProductInfoFromBreadcrumbs as g, passBreadcrumbsParams as p, storeBreadcrumbs as s };
